import * as t from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/TextStrikethrough.es.js";
const e = t.forwardRef((o, r) => /* @__PURE__ */ t.createElement(a, { ref: r, ...o, weights: i }));
e.displayName = "TextStrikethroughIcon";
const h = e;
export {
  h as TextStrikethrough,
  e as TextStrikethroughIcon
};
